import { createRouter, createWebHistory } from 'vue-router';

const ligacoes = () => import('@/containers/ligacoes.vue');
const apresentacao = () => import('@/containers/apresentacao.vue'); 
const eventos = () => import('@/containers/noticias.vue'); 
const composicao = () => import('@/containers/composicao.vue');
const documentacao = () => import('@/containers/documentacao.vue');

let baseUrl = window.lang == "en" ?
    import.meta.env.VITE_APP_BASEURLEN :
    import.meta.env.VITE_APP_BASEURL;

const router = createRouter({
  history: createWebHistory(baseUrl),
  routes: [ 
    { 
      name: "apresentacao",
      path: '/apresentacao',
      component: apresentacao     
    },
    { 
      name: "composicao",
      path: '/composicao',
      component: composicao     
    },
    {
      name: "relatorios",
      path: "/relatorios",
      component: documentacao
    },
    { 
      name: "eventos",
      path: '/eventos',
      component: eventos      
    },
    { 
      name: "ligacoes",
      path: '/ligacoes',
      component: ligacoes      
    },
    { path: '/', redirect: '/apresentacao' },
    { path: "/:catchAll(.*)", redirect: '/apresentacao'}  
  ],
  scrollBehavior() {
    return { top: 0 }
  },
})

export default router
